import { SignIn } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { CornerLanguageSelector } from '@/components/corner-language-selector';
import { AuthPageFooter } from '@/components/auth/auth-page-footer';
import { AuthPageSiteLinks } from '@/components/auth/auth-page-site-links';
import { keepSignInSearch } from '@/config/sign-in-redirect';
import { usePageTitle } from '@/hooks/use-page-title';

export const Route = createFileRoute('/sign-in/$')({
    validateSearch: keepSignInSearch,
    component: SignInPage,
});

function SignInPage() {
    const { t } = useTranslation();
    usePageTitle(t('pageTitle.signIn'));
    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-4">
            <CornerLanguageSelector />
            <AuthPageSiteLinks />
            <SignIn
                routing="path"
                path="/sign-in"
                signUpUrl="/sign-up"
                fallbackRedirectUrl="/"
                // In Waitlist mode the sign-in→sign-up transfer can't complete
                // (sign-up-or-in is unavailable when sign-ups are gated), so an
                // OAuth sign-in for an account that doesn't exist loops back to
                // /sign-in. Disabling the transfer resolves the attempt on this
                // page instead, where the "Join the waitlist" link is shown.
                transferable={false}
            />
            <AuthPageFooter />
        </div>
    );
}
